import { Injectable } from '@angular/core';
import { Region } from '@models/region';
import { FormDataService } from '@services/form-data/form-data.service';
import { BehaviorSubject, Observable, filter, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RegionStateService {
    constructor(private formService: FormDataService) {}
    private readonly regions = new BehaviorSubject<Region[] | null>(null);

    public getRegions(): Observable<Region[]> {
        if (this.regions.getValue() == null)
            this.formService
                .getRegions()
                .pipe(tap((res) => this.regions.next(res)))
                .subscribe();
        return this.regions.asObservable().pipe(filter(Boolean));
    }
}
